// hidden keyword는 api에서 확인

export const EXTERNAL_COMMON = "EXTERNAL_COMMON";
export const STARBALLON_AUTO_CHARGE = "STARBALLON_AUTO_CHARGE";
export const PPV_EVENT = "PPV_EVENT";
export const SOOPI_SUBSCRIPTION = "SOOPI_SUBSCRIPTION";
export const HIDDEN_KEYWORDS = [
    {
        alias: "외부_브라우저_호출",
        encrypt_value:
            "eyJpdiI6IkNmZ2lBSVhvQ0JxaVlzU2N3S0pwNlE9PSIsInZhbHVlIjoieEI1ekNTcHZZNlJGQjVtejJpc3c4bDJhOWd4RnF6YXFUQVRYOUM5UDl5ND0iLCJtYWMiOiJkMmViYjEyYTBiMjc5MjkzMzNhNWIxYTNkMWVhNGQxNTAwYzU1MWMyMmNlMjk4ZTNmMmE4MGRkNzdlZmZiZmJjIn0",
        decrypt_value: EXTERNAL_COMMON,
    },
    {
        alias: "별풍선_자동충전_이벤트",
        encrypt_value:
            "eyJpdiI6ImoxclZyUXpxV1ZyRTZndmNDTG00cmc9PSIsInZhbHVlIjoiVFJ5b05YT1BoVFhnZzNVazhzNVNvSWF6Y2FQQzJBR1lEWlwvSStzeWJvU2c9IiwibWFjIjoiNWU3NzY4ZjFlODI0ZjVlODQ4ZDFhMDZlMjcyNzljNTk3YWQxNzZlMTFhZTRlNDJjMzE5ZDU3NTI4NzQxNjk2YyJ9",
        decrypt_value: STARBALLON_AUTO_CHARGE,
    },
    {
        alias: "PPV_이벤트",
        encrypt_value:
            "eyJpdiI6Ijc2dk8yT0p1OWtNM3YrXC9QTWRjXC9Ndz09IiwidmFsdWUiOiJFcXNiWUdFWjBUSDQxK0VWMDJqQ2FSdmdIdkMzc2xUamQrVUQwQ0V2UHNJPSIsIm1hYyI6IjcxZjdkYzUyMjc3ZDAyZDFlNThmZGQ0MzE4NmY3ZmZhNDdiMmRmNDAxYmQ3ZTg5ZDE0YmZiOGM1NjU1YTc0NTYifQ",
        decrypt_value: PPV_EVENT,
    },
    {
        alias: "SOOPi 구독",
        encrypt_value:
            "eyJpdiI6IjNHN1FnYWM2cG5Hb3VZMzNCUk4zOVE9PSIsInZhbHVlIjoib2Y2ZTNHOFp5akFsOG94RERaM3pPNlhtUU5iVzRPK3QybGVyRkdaSzJEcz0iLCJtYWMiOiI4MzE0ODE4MzBjNWQ5ZmE2NDgzMmJlNjAzYzg1N2UxMThmOTdmZTIzMmJhY2JhMmY3YzVlNmUyMjgxZWQ0NjUyIn0=",
        decrypt_value: SOOPI_SUBSCRIPTION,
    },
];

